module.exports = __webpack_public_path__ + "img/itx-file-type-video.580fbdd3.svg";